export interface RegisterDefaultParameterOrderRequest {
  configBranchCode: string
  searchType: string
  orderDate: string
  traderCode: string
  acceptType: string
  buyDepartmentCode: string
  donorCode: string
  budgetYear: number | string
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  collectionType: string
  allBranchFlag: boolean
}

export function RegisterDefaultParameterOrderRequestToJSON(
  value: RegisterDefaultParameterOrderRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined,
    search_type: value.searchType !== '' ? value.searchType : undefined,
    order_date: value.orderDate !== '' ? value.orderDate : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    buy_department_code:
      value.buyDepartmentCode !== '' ? value.buyDepartmentCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear !== '' ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    all_branch_flag: value.allBranchFlag ?? undefined
  }
}
